export default "__VITE_ASSET__BICM93dy__"